// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"dceff99e","721":"dceff99e"}[chunkId] + ".chunk.css";
};